import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import initSentry from 'ui-lib/initSentry'
import setupCabinetClient from 'ui-lib/setupCabinetClient'
import { uk } from 'zod/locales'
import { config } from 'zod/mini'

import { client } from '~/api/client.gen'
import { zApiResponseError } from '~/api/zod.gen'

config(uk())

/* v8 ignore start */
// self-hosted Sentry (sentry.ctn) serves HTTP only — HTTPS would break it
// eslint-disable-next-line unicorn/prefer-https
const SENTRY_DSN = 'http://239dbaa1f5079d48a1226260ec33d472@sentry.ctn/38'

if (import.meta.env.PROD && import.meta.env.MODE === 'production') initSentry(SENTRY_DSN)

setupCabinetClient(client, zApiResponseError)
/* v8 ignore stop */

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<HydratedRouter />
		</StrictMode>,
	)
})
